import { Modal, Text, Stack, Paper, Group, Title, Rating } from "@mantine/core";

const ModalCriteriaRatings = ({ opened, onClose, ratings }) => {

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Text fw={700} size="xl">Valoraciones de Criterio</Text>}
      size="lg"
      radius="md"
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 2,
      }}
    >
      <Stack spacing="md">
        {ratings?.length > 0 ? (
          ratings.map((assessment, index) => (
            <Paper
              key={index}
              shadow="xs"
              radius="md"
              p="md"
              withBorder
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <Group position="apart" align="flex-start">
                <div>
                  <Title order={4} fw={500}>
                    {assessment.vc_webinsuser}
                  </Title>
                  <Text size="sm" mt="xs">
                    {assessment.comentarios || "Sin comentarios"}
                  </Text>
                </div>
                <Rating value={assessment.puntuacion} count={4} readOnly />
              </Group>
            </Paper>
          ))
        ) : (
          <Text c="dimmed" ta="center">
            No hay valoraciones disponibles.
          </Text>
        )}
      </Stack>
    </Modal>
  );
};

export default ModalCriteriaRatings;